import script from "./Copyright.vue?vue&type=script&setup=true&lang=js"
export * from "./Copyright.vue?vue&type=script&setup=true&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=1e9dd21a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9dd21a"]])

export default __exports__